import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { FIELD_SX } from '../WeldAssure/BrandedForm';


// CSelect — controlled-with-initial-value Select wrapper.
// Fix 2026-05-05 (Dean QA report bug #3): the prior version always started
// internal state at '' and ignored both `initialValue` and `setinitialValue`
// props that EditJob.jsx passes, so the Edit Job modal rendered the
// "Select Status" placeholder for jobs with an existing status (e.g.
// in_process). Fix: seed internal state from `initialValue`, sync on later
// updates, and forward changes to either `setValue` or `setinitialValue`
// (the spelling EditJob uses) for back-compat with both call sites.
export default function CSelect(props) {
  const [value, setValue] = React.useState(props.initialValue || '');

  React.useEffect(() => {
    if (
      props.initialValue !== undefined &&
      props.initialValue !== null &&
      props.initialValue !== value
    ) {
      setValue(props.initialValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.initialValue]);

  const handleChange = (event) => {
    const next = event.target.value;
    setValue(next);
    if (typeof props.setValue === 'function') props.setValue(next);
    if (typeof props.setinitialValue === 'function') props.setinitialValue(next);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth sx={FIELD_SX}>
        <InputLabel id="demo-simple-select-label">{props.label}</InputLabel>
        <Select
          disabled={props.disabled ? props.disabled : false}
          style={{ width: '100%' }}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label={props.label}
          onChange={handleChange}
        >
          {props.data && props.data.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label ?? item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
